import { PAGE_FEEDBACK_MAX_LENGTH } from "@productlane/api/src/lib/constants"

export { PAGE_FEEDBACK_MAX_LENGTH }

const COUNTER_VISIBLE_FROM = 200

export function canSubmitFeedback(value: string) {
	const length = value.trim().length
	return length > 0 && length <= PAGE_FEEDBACK_MAX_LENGTH
}

export function remainingFeedbackCharacters(value: string) {
	return PAGE_FEEDBACK_MAX_LENGTH - value.trim().length
}

export function shouldShowFeedbackCounter(value: string) {
	return remainingFeedbackCharacters(value) <= COUNTER_VISIBLE_FROM
}
